import { defineActions } from './defineActions'

/**
 * Quotation (OT inquiry/quote). Action names start with Quotation.
 *
 * The footer Save / Create of the quotation are page actions (Ime.Quotation.Save,
 * Ime.Quotation.Create, Ime.Case.SaveFromQuotationInit in ime-page.ts). "Create Booking" only
 * pre-fills the case in memory (the footer Save submits it), so it has no action of its own.
 */
export const quotationActions = defineActions({
  'Quotation.OtCost.Add': {
    label: 'Add OT',
    area: 'Quotation',
    description:
      'Save in the "Add Recommended OT and Cost" modal (client-only until the quotation exists).',
  },
  'Quotation.OtCost.Update': {
    label: 'Edit OT',
    area: 'Quotation',
    description: 'Save in the "Edit Recommended OT and Cost" modal.',
  },
  'Quotation.OtCost.Delete': {
    label: 'Delete OT',
    area: 'Quotation',
    description: 'Delete on a row of the "Recommended OT and Cost" table.',
  },
  'Quotation.Template.UpdateStaffLetter': {
    label: 'Edit quotation template to Staff',
    area: 'Quotation',
  },
  'Quotation.Template.UpdateCmLetter': {
    label: 'Edit quotation template to Booking CM',
    area: 'Quotation',
  },
  'Quotation.Quote.ResendToStaff': {
    label: 'Resend OT quote to Staff PIC',
    area: 'Quotation',
  },
  'Quotation.Quote.ResendToBookingCm': {
    label: 'Resend OT quote to Booking CM',
    area: 'Quotation',
  },
  'Quotation.Cancellation.ResendToStaff': {
    label: 'Resend cancellation notice to Staff PIC',
    area: 'Quotation',
  },
  'Quotation.Cancellation.ResendToBookingCm': {
    label: 'Resend cancellation notice to Booking CM',
    area: 'Quotation',
  },
})
